//import { parse } from 'html-react-parser';
import parse from 'html-react-parser';

export const SubmitArea = ({ content }) => {
	//var parse = require('html-react-parser');
	return (
		<div>{parse(content)}</div>
	);
};
